import { InferType, mixed, object, string } from 'yup'

import { requiredMessage } from 'directFlow/state/config/content'

import { VehicleFuelType } from 'types'

export const manualVehicleLookupDefaultValues = {
  manuallyEnteredVehicle: undefined,
}

export const manuallyEnteredVehicleSchema = object({
  make: string().required(requiredMessage),
  model: string().required(requiredMessage),
  manufactureYear: string().required(requiredMessage),
  fuelType: mixed<VehicleFuelType>()
    .oneOf(Object.values(VehicleFuelType))
    .required(requiredMessage),
  groupedTransmission: string().required(requiredMessage),
  engineSize: string().when('fuelType', {
    is: 'ELECTRIC',
    then: () => string().nullable().optional(),
    otherwise: () => string().required(requiredMessage),
  }),
  trim: string().required(requiredMessage),
}).default(undefined)

export const manualVehicleLookupSchema = object({
  manuallyEnteredVehicle: manuallyEnteredVehicleSchema.required(requiredMessage),
})

export type ManuallyEnteredVehicle = InferType<typeof manuallyEnteredVehicleSchema>
export type ManualVehicleLookupSchemaType = InferType<typeof manualVehicleLookupSchema>
